export default __webpack_public_path__ + "static/statrysLogo-2dc5548809e9c891573abc4635d49ba0.svg";